module.exports = __webpack_public_path__ + "static/media/logo.9e9182b0.svg";